import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import LocationSearch from './index'
import SearchIcon from './SearchIcon'
import { CharIcon } from '~/components'
import { formatLocationTitle } from '~/utils/format'
import * as styles from './mobileOverlay.module.css'

export default function MobileOverlay({ field, form, placeholder, fullscreen, onFocus, onBlur, ...rest }) {
  const { t } = useTranslation()
  const [overlayOpen, setOverlayOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 970)

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 970)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  // Prevent body scroll while overlay is open
  useEffect(() => {
    if (overlayOpen) document.body.style.overflow = 'hidden'
    else document.body.style.overflow = ''
    return () => { document.body.style.overflow = '' }
  }, [overlayOpen])

  if (!isMobile) {
    return (
      <LocationSearch
        field={field}
        form={form}
        placeholder={placeholder}
        fullscreen={fullscreen}
        onFocus={onFocus}
        onBlur={onBlur}
        {...rest}
      />
    )
  }

  const isSelected = typeof field.value === 'object'
  const displayValue = isSelected ? formatLocationTitle(field.value) : null

  return (
    <>
      <div className={styles.trigger} onClick={() => setOverlayOpen(true)}>
        {isSelected
          ? <CharIcon char={'ABCDEFGHIJKLMNOPQRST'[rest.fieldIndex]} className={styles.triggerIcon} />
          : <SearchIcon className={styles.triggerIcon} active={false} />
        }
        <span className={isSelected ? styles.triggerValue : styles.triggerPlaceholder}>
          {displayValue || placeholder}
        </span>
      </div>

      {overlayOpen && createPortal(
        <div className={styles.overlay}>
          <div className={styles.header}>
            <span className={styles.title}>{placeholder}</span>
            <button className={styles.cancel} onClick={() => setOverlayOpen(false)}>
              {t('button-cancel')}
            </button>
          </div>
          <div className={styles.content}>
            <LocationSearch
              field={field}
              form={form}
              placeholder={placeholder}
              fullscreen={true}
              mobileOverlay={true}
              onMobileSelect={() => setOverlayOpen(false)}
              {...rest}
            />
          </div>
        </div>,
        document.body
      )}
    </>
  )
}
